export const ORDER_PROJECT_STATUS = 'Проект поручения';

export const PERIOD_OPTIONS = [
  {
    text: 'Единоразовый отчет',
    value: 1,
  },
  {
    text: 'Ежеквартальный отчет',
    value: 2,
  },
  {
    text: 'Полугодовой отчет',
    value: 3,
  },
];
